import React, { Component } from "react";
import { Row, Col, PageHeader, Layout, DatePicker } from "antd";
import moment from "moment";
import "moment/locale/es";

import { CardTotal, CardTopProyectosIngresos, CardTopProyectosEgresos, } from "../../../Widgets/CardsDashboardProyectos/Cards";
import GraficaDashboardProyectos from "../../../Widgets/CardsDashboardProyectos/Grafica/GraficaDashboardProyectos";

const { Content } = Layout
moment.locale("es")

class DashboardProyectos extends Component {
  constructor(props) {
    super(props)
    this.state = {
      desde: moment().subtract(11, "month").startOf("month"),
      hasta: moment().endOf("day"),
    }
  }

  handleDesde = (d) => {
    if (!d) return
    const nuevoDesde = d.startOf("day")
    let { hasta } = this.state
    if (hasta && nuevoDesde.isAfter(hasta, "day")) {
      hasta = nuevoDesde.clone().endOf("day")
    }
    this.setState({ desde: nuevoDesde, hasta })
  }

  handleHasta = (h) => {
    if (!h) return
    const nuevoHasta = h.endOf("day")
    let { desde } = this.state
    if (desde && nuevoHasta.isBefore(desde, "day")) {
      desde = nuevoHasta.clone().startOf("day")
    }
    this.setState({ desde, hasta: nuevoHasta })
  }

  render() {
    const { desde, hasta } = this.state
    const qDesde = desde.toDate().toISOString()
    const qHasta = hasta.toDate().toISOString()

    return (
      <>
        <PageHeader
          className="page-header custom-header"
          title="Dashboard de Proyectos"
          extra={
            <div className="date-range">
              <DatePicker
                value={desde}
                onChange={this.handleDesde}
                allowClear={false}
                format="YYYY/MM/DD"
                inputReadOnly
                className="date-range-picker date-range-start"
                disabledDate={(cur) => !!hasta && cur && cur.isAfter(hasta, "day")}
              />
              <span className="date-range-separator">→</span>
              <DatePicker
                value={hasta}
                onChange={this.handleHasta}
                allowClear={false}
                format="YYYY/MM/DD"
                inputReadOnly
                className="date-range-picker date-range-end"
                disabledDate={(cur) => !!desde && cur && cur.isBefore(desde, "day")}
              />
            </div>
          }
        />

        <Content className="admin-content content-bg padding-1">
          <Row gutter={[16, 16]} style={{ padding: "16px" }}>
            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <CardTotal desde={qDesde} hasta={qHasta} />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <CardTopProyectosIngresos desde={qDesde} hasta={qHasta} />
            </Col>

            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
              <CardTopProyectosEgresos desde={qDesde} hasta={qHasta} />
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ padding: "0 16px 16px" }}>
            <Col span={24}>
              <GraficaDashboardProyectos desde={qDesde} hasta={qHasta} />
            </Col>
          </Row>
        </Content>
      </>
    );
  }
}

export default DashboardProyectos;
